/* eslint-disable camelcase */
import { addJourney } from '@state/builders/journeys/helpers'
import { getJourneysByIds } from '@state/queries/journeys/get-journeys'

export const createJourneysOnSearch = (
  outwardJourneys,
  inwardJourneys,
  bookingId
) => {
  if (outwardJourneys.length) {
    const updatedJourneys = outwardJourneys.map((journey) => {
      return {
        ...journey,
        direction: 'outward',
      }
    })

    addJourney({
      data: [...updatedJourneys],
    }).then(({ journeys }) => {
      const ojp_response_journeys = getJourneysByIds(
        journeys.map((journey) => journey.id)
      )

      addJourney({
        data: {
          direction: 'outward',
          booking_id: bookingId,
          journey_planner_response: ojp_response_journeys,
        },
      })
    })
  }

  if (inwardJourneys.length) {
    addJourney({
      data: [...inwardJourneys],
    }).then(({ journeys }) => {
      const ojp_response_journeys = getJourneysByIds(
        journeys.map((journey) => journey.id)
      )

      addJourney({
        data: {
          direction: 'return',
          booking_id: bookingId,
          journey_planner_response: ojp_response_journeys,
        },
      })
    })
  }
}
